"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrthoContractStatus_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var OrthoContractStatus_Factory = /** @class */ (function () {
    function OrthoContractStatus_Factory() {
    }
    OrthoContractStatus_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    OrthoContractStatus_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return OrthoContractStatus_Factory;
}());
exports.OrthoContractStatus_Factory = OrthoContractStatus_Factory;
